import ruleSetExecutor from './ruleSetExecutor';
import ruleExecutor from './ruleExecutor';
import actionExecutor from './actionExecutor';

const buildRuleSetExecutor = (dataConnections, viewManager, logging) =>
    ruleSetExecutor(
        ruleExecutor(
            actionExecutor(
                dataConnections,
                viewManager,
            ),
        ),
        logging,
    );


export default buildRuleSetExecutor;